module.exports = __webpack_public_path__ + "static/media/cover-logo.f65019ea.png";